angular.module('env.data.batching.batchingProvider', [])

    .provider('batching', function () {
        var batchingProvider = this;

        var batchers = [];
        var defaultDelay = 100;

        var defaultBatcherConfig = {
            maxQueueSize: 10,
            minQueueSize: 2,
            delay: defaultDelay,
            url: /.*/,
            methods: ['GET', 'HEAD', 'POST', 'PUT', 'DELETE']
        };

        var serviceConfig = {
            autoBatching: false,
            enabled: false,
            batchUrl: '/batch'
        };

        function setDefaultBatcherConfig(config) {
            if (config) {
                angular.extend(defaultBatcherConfig, config);
            }
        }

        function setConfig(config) {
            if (config) {
                angular.extend(serviceConfig, config);
            }
        }

        function addBatcher(batcherConfig) {
            batchers.push(angular.extend({}, defaultBatcherConfig, batcherConfig));
        }

        function getBathers() {
            return batchers;
        }

        function isEnabled() {
            return serviceConfig.enabled === true || serviceConfig.enabled === 'true';
        }

        angular.extend(batchingProvider, {
            setDefaultBatcherConfig: setDefaultBatcherConfig,
            setConfig: setConfig,
            addBatcher: addBatcher,
            getBathers: getBathers,
            isEnabled: isEnabled
        });

        this.$get = ["$timeout", "$injector", function ($timeout, $injector) {

            var $http;

            /**
             * Request processors
             * @type {Array<RequestBatcherProcessor>}
             */
            var processors = [];
            var forcedBatchProcessor;

            return {
                forceStartBatch: forceStartBatch,
                processRequest: processRequest,
                addBatcher: addBatcher,
                getBathers: getBathers,
                isEnabled: isEnabled
            };

            function forceStartBatch(requestCount, asTransaction) {
                if (forcedBatchProcessor) {
                    throw new Error("Forced batch is started already");
                }
                _.forEach(processors, function (processor) {
                    processor.send();
                });

                forcedBatchProcessor = new ForcedBatchProcessor(requestCount, asTransaction);
            }

            function processRequest(requestConfig) {

                if (!isEnabled() ||
                    (requestConfig.method.toUpperCase() === "POST" &&
                    requestConfig.url.indexOf(serviceConfig.batchUrl) > -1)) {
                    requestConfig.continueDownNormalPipeline();
                    return;
                }

                if (forcedBatchProcessor) {
                    forcedBatchProcessor.addRequest(requestConfig);
                    return;
                }

                if (!serviceConfig.autoBatching) {
                    requestConfig.continueDownNormalPipeline();
                    return;
                }

                var batcher = getBatcher(requestConfig);
                if (!batcher) {
                    requestConfig.continueDownNormalPipeline(); // normal pipeline
                    return;
                }

                getOrCreateProcessor(batcher).addRequest(requestConfig);
            }

            function getBatcher(requestConfig) {
                for (var i = 0; i < batchers.length; i++) {
                    var batcher = batchers[i];

                    var isMethodAllowed = true;
                    if (batcher.methods) {
                        isMethodAllowed = _.any(batcher.methods, function (m) {
                            return m.toUpperCase() == requestConfig.method.toUpperCase();
                        });
                    }

                    var isPathAllowed = true;
                    if (batcher.url) {
                        if (_.isRegExp(batcher.url)) {
                            isPathAllowed = batcher.url.test(requestConfig.url);
                        } else if (_.isString(batcher.url)) {
                            isPathAllowed = requestConfig.url.indexOf(batcher.url) > -1;
                        } else {
                            isPathAllowed = false;
                        }
                    }

                    if (isMethodAllowed && isPathAllowed) {
                        return batcher;
                    }
                }
            }

            function getOrCreateProcessor(batcherConfig) {
                for (var i = 0; i < processors.length; i++) {
                    if (processors[i].getBatcher() === batcherConfig) {
                        return processors[i];
                    }
                }
                var newProcessor = new RequestBatcherProcessor(batcherConfig);
                processors.push(newProcessor);
                return newProcessor;
            }

            function sendBatchRequest(requests, asTransaction) {
                if (!requests || requests.length <= 0) {
                    return;
                }

                // We need unique id for each request
                for (var i = 0; i < requests.length; i++) {
                    requests[i].rid = 'r_' + i;
                }

                var batchBody = _.map(requests, function (r) {
                    return {
                        rid: r.rid,
                        method: r.method,
                        url: r.url,
                        data: _.isString(r.data) ? r.data : JSON.stringify(r.data),
                        headers: convertHeadersToObject(r.headers)
                    };
                });

                var httpConfig = {};
                if (asTransaction === true) {
                    if (!httpConfig.headers) {
                        httpConfig.headers = {};
                    }
                    httpConfig.headers['Batch-As-Transaction'] = true;
                }

                if (!$http) {
                    $http = $injector.get('$http', 'batching');
                }
                $http.post(serviceConfig.batchUrl, batchBody, httpConfig)
                    .then(function (resp) {
                        var responses = resp.data;
                        if (responses) {
                            for (var i = 0; i < requests.length; i++) {
                                var request = requests[i];
                                var response = _.find(responses, function (resp) {
                                    return resp.rid === request.rid;
                                });
                                if (!response) {
                                    request.callback(404, null, "", "NotFound");
                                } else {
                                    var data;
                                    try {
                                        data = JSON.parse(response.data);
                                    } catch (e) {
                                        data = response.data;
                                    }
                                    request.callback(
                                        response.statusCode,
                                        data,
                                        convertObjectHeadersToString(request.headers),
                                        response.statusText);
                                }
                            }
                        } else {
                            for (var j = 0; j < requests.length; j++) {
                                requests[j].callback(400, null, "", "BadRequest");
                            }
                        }
                    }, function (resp) {
                        if (resp) {
                            var headers = convertHeadersToString(resp.headers);
                            for (var i = 0; i < requests.length; i++) {
                                requests[i].callback(resp.status, resp.data, headers, resp.statusText);
                            }
                        } else {
                            for (var j = 0; j < requests.length; j++) {
                                requests[j].callback(400, null, "", "BadRequest");
                            }
                        }

                    });
            }

            function convertHeadersToObject(headers) {
                var result = [];
                for (var property in headers) {
                    if (headers.hasOwnProperty(property)) {
                        result.push({
                            key: property,
                            value: headers[property]
                        });
                    }
                }
                return result;
            }

            function convertObjectHeadersToString(headers) {
                var result = '';
                for (var i = 0; i < headers.length; i++) {
                    var header = headers[i];
                    result += header.key + ': ' + header.value + '\n';
                }
                return result;
            }

            function convertHeadersToString(headers) {
                var result = '';
                for (var property in headers) {
                    if (headers.hasOwnProperty(property)) {
                        result += property + ': ' + headers[property] + '\n';
                    }
                }
                return result;
            }

            function ForcedBatchProcessor(_requestCount, _asTransaction) {
                var requests = [];
                var asTransaction = !!_asTransaction;
                var requestCount = _requestCount;

                angular.extend(this, {
                    addRequest: addRequest,
                    send: send
                });

                function addRequest(requestConfig) {
                    requests.push(requestConfig);
                    requestCount--;
                    if (requestCount <= 0) {
                        forcedBatchProcessor = null;
                        send();
                    }
                }

                function send() {
                    sendBatchRequest(requests, asTransaction)
                }
            }

            function RequestBatcherProcessor(batcherConfig) {
                var requests = [];
                var me = this;

                // start timer
                var timeout = $timeout(send, batcherConfig.delay || defaultDelay, false);

                angular.extend(this, {
                    getBatcher: getBatcher,
                    addRequest: addRequest
                });

                function getBatcher() {
                    return batcherConfig;
                }

                function addRequest(request) {
                    requests.push(request);
                    if (batcherConfig.maxQueueSize > 0 && requests.length >= batcherConfig.maxQueueSize) {
                        send();
                    }
                }

                function send() {
                    $timeout.cancel(timeout);
                    timeout = undefined;
                    // remove processor from processors
                    var di = processors.indexOf(me);
                    if (di > -1) {
                        processors.splice(di, 1);
                    }

                    // check limitations
                    if (batcherConfig.minQueueSize > 0 && requests.length < batcherConfig.minQueueSize) {
                        // should let the request continue normally
                        angular.forEach(requests, function (request) {
                            request.continueDownNormalPipeline();
                        });
                        return;
                    }

                    sendBatchRequest(requests);
                }
            }
        }];
    })

    .config(function ($provide) {
        $provide.decorator('$httpBackend', [
            '$delegate',
            'batching',
            function ($delegate, batching) {
                var $httpBackendFn = function (method, url, post, callback, headers, timeout, withCredentials, responseType) {
                    var self = this;
                    var callArgs = arguments;

                    batching.processRequest({
                        method: method,
                        url: url,
                        data: post,
                        callback: callback,
                        headers: headers,
                        timeout: timeout,
                        withCredentials: withCredentials,
                        responseType: responseType,
                        continueDownNormalPipeline: function () {
                            $delegate.apply(self, callArgs);
                        }
                    });
                };

                // If we are testing using angular-mocks we need to provide their special methods
                // on the function we are returning otherwise your tests won't work :-(.
                if (angular.mock) {
                    angular.forEach($delegate, function (fn, key) {
                        $httpBackendFn[key] = fn;
                    });
                }

                return $httpBackendFn;
            }
        ]);
    })

;